<template>
  <paginated-list :actions="actions" :columns="columns" service="support-articles" state-key="supportArticles"/>
</template>

<script>
import PaginatedList from './PaginatedList.vue'

export default {
  name: 'SupportArticleFilter',

  components: {
    PaginatedList
  },

  computed: {
    actions () {
      return [{
        text: 'Edit',
        to: {
          name: 'support-centre.edit'
        }
      }]
    },

    columns () {
      return {
        title: 'Title',
        published: {
          header: 'Published',
          icons: {
            true: 'check',
            false: 'times'
          }
        }
      }
    }
  }
}
</script>
